import { GlobalConstants } from "./GlobalConstants";

const CreateFakeReceiptsUpTo = {};
CreateFakeReceiptsUpTo[GlobalConstants.UserRole.ROOT] = 100000.00;
CreateFakeReceiptsUpTo[GlobalConstants.UserRole.ADMIN] = 50.00;

export class GlobalPermissions {
    static readonly UX = {
        EXPENSES: {
            ShowTabs: {
                MissingReceipts: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN, GlobalConstants.UserRole.STANDARD],
                BoatCash: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN, GlobalConstants.UserRole.STANDARD],
                ReviewAndConfirm: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN, GlobalConstants.UserRole.STANDARD, GlobalConstants.UserRole.BASIC],
                ConfirmedReceipts: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN, GlobalConstants.UserRole.STANDARD],
            },
            MissingReceipt: {
                CreateFakeReceipts: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN],
                CreateFakeReceiptsUpTo,
            },
            BoatCash: {
                CreateBoatCashReceipts: [GlobalConstants.UserRole.ROOT],
                CreateBoatCashReceiptsLimited: [GlobalConstants.UserRole.ADMIN, GlobalConstants.UserRole.STANDARD],
                AllCategories: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN],
            },
            ReviewAndConfirm: {
                LimitedCategories: [ // Only 
                    // 'R$Root', // Fake & P$
                    // 'R$Admin', // Fake & P$
                    // 'R$User', // Fake & P$
                    `R${GlobalConstants.UserRole.ROOT}`, // Fake
                    `R${GlobalConstants.UserRole.ADMIN}`, // Fake
                    `R${GlobalConstants.UserRole.BASIC}`, // Fake
                    `$${GlobalConstants.UserRole.ROOT}`, // P$
                    `$${GlobalConstants.UserRole.ADMIN}`, // P$
                    // '$User', // P$
                    GlobalConstants.UserRole.ROOT,
                    GlobalConstants.UserRole.ADMIN,
                    GlobalConstants.UserRole.BASIC,
                ],
                CanReimburseReceipts: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN],
            }
        },
        REIMBURSEMENTS: {
            Pending: {
                ChangeUser: [GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN],
            }
        },
    }
}
